// ads.js
import React, { useState } from "react";
import AdUnit from "./AdUnit";

export const AD_POSITIONS = {
  paragraphAds: [3, 14, 30],
  nativeAd: "native-ad-300x250",
};

const ArticleAdSlot = ({ paragraphNumber, adUnitsRegistered, isMobile }) => {
  const [adRendered, setAdRendered] = useState(false);

  if (!adUnitsRegistered || !AD_POSITIONS.paragraphAds.includes(paragraphNumber)) {
    return null;
  }

  // Determine placeholder div id (if any)
  const divId = (() => {
    switch (paragraphNumber) {
      case 3:
        return isMobile ? "mob-box-ad-a" : null;
      case 14:
        return isMobile ? "mob-box-ad-b" : "dsk-box-ad-d";
      default:
        return isMobile ? "mob-box-ad-c" : "dsk-box-ad-e";
    }
  })();

  const placeholder = divId ? (
    <div className="flex justify-center items-center mb-[20px]" key={`ph-${paragraphNumber}-${isMobile ? "mob" : "dsk"}`}>
      <div id={divId} />
    </div>
  ) : null;

  const adUnitCode = (() => {
    switch (paragraphNumber) {
      case 3:
        return isMobile ? "inarticle-paragraph3-mobile" : null; // only mobile
      case 14:
        return isMobile ? "inarticle-paragraph14-mobile" : "inarticle-paragraph14";
      default:
        return isMobile ? "inarticle-paragraph30-mobile" : "inarticle-paragraph30";
    }
  })();

  if (!adUnitCode) return null;

  return [
    <div className="mb-[20px]" key={`wrapper-${adUnitCode}`}>
      <AdUnit
        adUnitCode={adUnitCode}
        onAdRendered={() => setAdRendered(true)}
      />
    </div>,
    !adRendered && placeholder,
  ];
};

const NativeAdSlot = ({ adUnitsRegistered }) => {
  const [adRendered, setAdRendered] = useState(false);

  if (!adUnitsRegistered) return null;

  return (
    <div className="mt-6 mb-[20px] flex justify-center items-center" key="paywall-native-ad">
      <AdUnit
        adUnitCode={AD_POSITIONS.nativeAd}
        onAdRendered={() => setAdRendered(true)}
      />
      {!adRendered && <div id="native-ad-a" key="fallback-native" />}
    </div>
  );
};

export const getArticleAd = (paragraphNumber, adUnitsRegistered, isMobile) => {
  if (!adUnitsRegistered || !AD_POSITIONS.paragraphAds.includes(paragraphNumber)) return null;

  return (
    <ArticleAdSlot
      paragraphNumber={paragraphNumber}
      adUnitsRegistered={adUnitsRegistered}
      isMobile={isMobile}
      key={`slot-${paragraphNumber}`}
    />
  );
};

export const getNativeAd = (adUnitsRegistered) => {
  if (!adUnitsRegistered) return null;
  return <NativeAdSlot adUnitsRegistered={adUnitsRegistered} key="native-slot" />;
};
